import React from 'react';
import {
  Box,
  Typography,
  Container,
  Button,
} from '@mui/material';

export default function Banner({ onNavigate }) {
  const scrollToCards = () => {
    const el = document.getElementById('cards');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      component="section"
      sx={{
        padding: '0 0 80px 0',
        background: '#0F2E2B',
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1C6758 0%, #153A35 100%)',
            borderRadius: '26px',
            padding: { xs: '40px 24px', md: '64px 60px' },
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: '40px',
            boxShadow: '0 20px 50px -20px rgba(0,0,0,0.5)',
            '&::before': {
              content: '""',
              position: 'absolute',
              right: '-60px',
              top: '-60px',
              width: '260px',
              height: '260px',
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(212, 162, 76, 0.35), transparent 70%)',
              pointerEvents: 'none',
            },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontFamily: '"Fraunces", serif',
              fontWeight: 700,
              fontSize: { xs: '26px', sm: '32px', md: '36px' },
              color: '#F5F1E6',
              maxWidth: '480px',
              lineHeight: 1.2,
              position: 'relative',
              zIndex: 1,
            }}
          >
            Your first coupon card pays for itself on the first redemption.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '14px',
              position: 'relative',
              zIndex: 1,
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            <Button
              variant="contained"
              onClick={scrollToCards}
              sx={{
                backgroundColor: '#D4A24C',
                color: '#0F2E2B',
                fontWeight: 600,
                fontSize: '14.5px',
                padding: '12px 24px',
                borderRadius: '12px',
                width: { xs: '100%', sm: 'auto' },
                '&:hover': {
                  backgroundColor: '#E8C078',
                },
              }}
            >
              Get a card — from ₹100
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderColor: 'rgba(245, 241, 230, 0.3)',
                color: '#F5F1E6',
                fontWeight: 600,
                fontSize: '14.5px',
                padding: '12px 24px',
                borderRadius: '12px',
                width: { xs: '100%', sm: 'auto' },
                '&:hover': {
                  borderColor: '#F5F1E6',
                  backgroundColor: 'rgba(245, 241, 230, 0.08)',
                },
              }}
              onClick={() => (onNavigate ? onNavigate('contact') : (window.location.href = '/contact'))}
            >
              Talk to us
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
